import { HEALTH_POWER_UP_RADIUS } from "./constants";
import { Box, Container } from "./react-graphics";

type Props = {
  x: number;
  y: number;
};

const HealthPowerUp = ({ x, y }: Props) => {
  return (
    <Container
      x={x}
      y={-y + 0.77 * HEALTH_POWER_UP_RADIUS}
      rotation={-Math.PI / 4}
    >
      <Box
        x={0.75 * HEALTH_POWER_UP_RADIUS}
        y={-0.75 * HEALTH_POWER_UP_RADIUS}
        width={0.75 * HEALTH_POWER_UP_RADIUS}
        height={0.75 * HEALTH_POWER_UP_RADIUS}
        fillColor={0xff0000}
        pivotX={0}
        pivotY={0}
      />
      <Box
        x={0}
        y={-1.5 * HEALTH_POWER_UP_RADIUS}
        width={0.75 * HEALTH_POWER_UP_RADIUS}
        height={1.5 * HEALTH_POWER_UP_RADIUS}
        fillColor={0xff0000}
        pivotX={0}
        pivotY={0}
      />
    </Container>
  );
};

export default HealthPowerUp;
